import { render, staticRenderFns } from "./GetRedirects.vue?vue&type=template&id=5eb7cee3&scoped=true"
import script from "./GetRedirects.vue?vue&type=script&lang=js"
export * from "./GetRedirects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb7cee3",
  null
  
)

export default component.exports